var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealthcare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 140,
    viewBox: "0 0 144 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.677979 0.570313H115.992V5.43372H0.677979V0.570313Z",
    fill: "#255056"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54169 0.570313L5.54169 139.182H0.678279L0.677979 0.570313H5.54169Z",
    fill: "#255056"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.992 0.570313L115.992 139.182H111.128V0.570312L115.992 0.570313Z",
    fill: "#255056"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7667 0.570313V72.3078H55.9032V0.570312L60.7667 0.570313Z",
    fill: "#255056"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M143.603 67.4444V139.182H138.74V67.4444H143.603Z",
    fill: "#255056"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1542 0.570313L33.1542 134.318H28.2908L28.2908 0.570312L33.1542 0.570313Z",
    fill: "#255056"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3791 0.570313V134.318H83.5157L83.5157 0.570312L88.3791 0.570313Z",
    fill: "#255056"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.677979 34.0073H115.992V38.8707H0.677979V34.0073Z",
    fill: "#255056"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.677979 67.4444H143.603V72.3078H0.677979V67.4444Z",
    fill: "#255056"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.677979 100.881H143.603V105.745H0.677979V100.881Z",
    fill: "#255056"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0.677979 134.318H143.603V139.182H0.678279L0.677979 134.318Z",
    fill: "#255056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthcare);
export default __webpack_public_path__ + "static/media/healthcare.3422fa5b4068ba9a8664cb0a1d48b2f8.svg";
export { ForwardRef as ReactComponent };